import React, { createElement } from "react";
import { connect } from "react-redux";
import { MenuItemLink, getResources, Responsive, translate } from "react-admin";
import { withRouter } from "react-router-dom";
import { getUserCompanyRole, getPolicies } from "../common/authClient";
import { POLICY_ROLE_MAPPINGS } from "../common/rolesManagement";

// import LabelIcon from "@material-ui/icons/Label";

const MyMenuComponent = ({ translate, resources, onMenuClick, logout }) => (
    <div>
        {resources.map(resource => {
            if (resource.icon) {
                const policies = getPolicies(getUserCompanyRole());
                if (
                    resource.name === "role-mappings" &&
                    policies &&
                    !policies.includes(POLICY_ROLE_MAPPINGS.READ)
                ) {
                    return null;
                } else if (resource.name === "customers-mappings") {
                    return null;
                }
                if (resource.name === "profile") {
                    return (
                        <Responsive
                            key={resource.name}
                            small={
                                <MenuItemLink
                                    key={resource.name}
                                    to={`/${resource.name}`}
                                    primaryText={translate(
                                        `resources.${resource.name}.namePlural`
                                    )}
                                    leftIcon={createElement(resource.icon)}
                                    onClick={onMenuClick}
                                />
                            }
                            medium={null} // Pass null to render nothing on larger devices
                        />
                    );
                }
                return (
                    <MenuItemLink
                        key={resource.name}
                        to={`/${resource.name}`}
                        primaryText={translate(
                            `resources.${resource.name}.namePlural`
                        )}
                        leftIcon={createElement(resource.icon)}
                        onClick={onMenuClick}
                    />
                );
            } else {
                return null;
            }
        })}
        {/* <MenuItemLink
            to="/custom-rougetRolePoliciese"
            primaryText="MigetRolePoliciescellaneous"
            leftIcon={<LabegetRolePoliciesIcon />}
            onClick={onMenugetRolePolicieslick}
        /> */}
        <Responsive
            small={logout}
            medium={null} // Pass null to render nothing on larger devices
        />
    </div>
);

const mapStateToProps = state => ({
    resources: getResources(state)
});

const MyMenu = translate(withRouter(connect(mapStateToProps)(MyMenuComponent)));

export default MyMenu;



// WEBPACK FOOTER //
// ./src/components/MyMenu.js